<!-- Backdrop mobile -->
@if (mobileOpen()) {
  <div class="fixed top-30 lg:top-20 inset-x-0 bottom-0 bg-black/40 z-30 lg:hidden"
       (click)="mobileClose.emit()"></div>
}

<aside class="w-64 flex flex-col
              fixed top-30 left-0 bottom-0 z-40
              lg:relative lg:top-auto lg:left-auto lg:bottom-auto lg:h-full lg:z-30
              bg-white dark:bg-gray-900 shadow-lg border-r border-gray-200 dark:border-gray-800
              transition-all duration-300 lg:translate-x-0"
  [class.translate-x-0]="mobileOpen()"
  [class.-translate-x-full]="!mobileOpen()"
  [class.lg:w-16]="isCollapsed()"
  id="sidebar">

  <!-- Botón colapsar flotante (solo desktop) -->
  <button type="button" (click)="collapsed.set(!isCollapsed())"
    class="hidden lg:flex items-center justify-center
           absolute -right-3 top-6 z-50
           w-6 h-6 rounded-full
           bg-white dark:bg-gray-900
           border border-gray-200 dark:border-gray-700
           text-gray-400 hover:text-primary hover:border-primary
           shadow-sm transition-all duration-200"
    [title]="isCollapsed() ? 'Expandir menú' : 'Colapsar menú'">
    @if (isCollapsed()) {
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7"/>
      </svg>
    } @else {
      <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7"/>
      </svg>
    }
  </button>

  <!-- Nav -->
  <nav class="px-2 pt-2 pb-4 flex-1 space-y-1 overflow-y-auto lg:overflow-visible"
       [class.pr-4]="!isCollapsed()">
    @for (item of menuItems; track item.ruta) {
      @if (item.ruta === '/buscador') {
        <div class="pt-3 mt-2 border-t border-gray-100 dark:border-gray-800">
          <a [routerLink]="item.ruta"
            class="relative group flex items-center rounded-xl text-sm font-medium transition"
            [class]="item.isActive() ? 'bg-primary text-primary-content shadow-md' : item.color + ' hover:bg-gray-100 dark:hover:bg-gray-800'"
            [class.px-3]="!isCollapsed()" [class.py-2]="!isCollapsed()" [class.gap-3]="!isCollapsed()"
            [class.justify-center]="isCollapsed()" [class.p-3]="isCollapsed()">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
              <use [attr.href]="'/svg/sprite.svg#' + item.icono"></use>
            </svg>
            @if (!isCollapsed()) { {{ item.titulo }} }
            @if (isCollapsed()) {
              <span class="pointer-events-none absolute left-full ml-3 px-2.5 py-1.5 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50 shadow-lg">{{ item.titulo }}</span>
            }
          </a>
        </div>
      } @else {
        <a [routerLink]="item.ruta"
          class="relative group flex items-center rounded-xl text-sm font-medium transition"
          [class]="item.isActive() ? 'bg-primary text-primary-content shadow-md' : item.color + ' hover:bg-gray-100 dark:hover:bg-gray-800'"
          [class.px-3]="!isCollapsed()" [class.py-2]="!isCollapsed()" [class.gap-3]="!isCollapsed()"
          [class.justify-center]="isCollapsed()" [class.p-3]="isCollapsed()">
          <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24">
            <use [attr.href]="'/svg/sprite.svg#' + item.icono"></use>
          </svg>
          @if (!isCollapsed()) { {{ item.titulo }} }
          @if (isCollapsed()) {
            <span class="pointer-events-none absolute left-full ml-3 px-2.5 py-1.5 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50 shadow-lg">{{ item.titulo }}</span>
          }
        </a>
      }
    }

  </nav>

  <!-- Tema claro/oscuro -->
  <div class="px-2 py-3 border-t border-gray-100 dark:border-gray-800">
    @if (!isCollapsed()) {
      <button type="button" (click)="toggleTheme()"
        class="w-full flex items-center justify-center gap-2 bg-primary hover:bg-primary-focus text-primary-content rounded-lg px-3 py-2.5 text-sm font-medium transition-all">
        @if (currentTheme() === 'tramitex') {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>
          Modo Oscuro
        } @else {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1m-16 0H1m15.364 1.636l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
          Modo Claro
        }
      </button>
    } @else {
      <button type="button" (click)="toggleTheme()"
        class="relative group w-full flex items-center justify-center p-2 rounded-lg hover:bg-primary hover:text-primary-content text-gray-600 dark:text-gray-400 transition">
        @if (currentTheme() === 'tramitex') {
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>
        } @else {
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1m-16 0H1m15.364 1.636l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
        }
        <span class="pointer-events-none absolute left-full ml-3 px-2.5 py-1.5 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50 shadow-lg">
          {{ currentTheme() === 'tramitex' ? 'Modo Oscuro' : 'Modo Claro' }}
        </span>
      </button>
    }
  </div>


</aside>



